
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor1On as ObiResistor1OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-1-on.js';
 
 
 

 
 export const ObiResistor1On = createComponent({
   react: React,
   tagName: 'obi-resistor-1-on',
   elementClass: ObiResistor1OnElement,
   events: {
     
   }
  });
 
 